import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Announcement } from '@app/core/interfaces/c5/announcement';
import { CallCenterAnnouncementSettings } from '@app/shared/acd-cc/components/call-center-announcements-settings/call-center-announcement-settings';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CallCenterAnnouncementRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  add(callCenterId: number, callCenterAnnouncement: Partial<Announcement>, file: File): Observable<void> {
    const formData = new FormData();

    formData.append('description', callCenterAnnouncement.description);

    if (file !== undefined) {
      formData.append('file', file, file.name);
    }

    return this.utils.apiUrl(`/callCenter/${callCenterId}/announcement`).pipe(
      mergeMap((url) =>
        this.http.post<void>(url, formData, {
          params: {
            type: callCenterAnnouncement.type,
          },
        })
      ),
      wrapError('call-center-announcement-repository:add')
    );
  }

  delete(callCenterId: number, id: number): Observable<void> {
    return this.utils.apiUrl(`/callCenter/${callCenterId}/announcement/${id}`).pipe(
      mergeMap((url) => this.http.delete<void>(url)),
      wrapError('call-center-announcement-repository:delete')
    );
  }

  list(callCenterId: number): Observable<Announcement[]> {
    return this.utils
      .apiUrl(
        `/callCenter/${callCenterId}/announcement?ccQueuesAnnouncementsToo=false&domainAnnouncementsToo=true`
      )
      .pipe(
        mergeMap((url) => this.http.get<Announcement[]>(url)),
        wrapError('call-center-announcement-repository:list')
      );
  }

  update(callCenterId: number, callCenterAnnouncement: Announcement, file?: File): Observable<void> {
    const formData = new FormData();

    formData.append('announcement', JSON.stringify(callCenterAnnouncement));

    if (file != undefined) {
      formData.append('file', file, file.name);
    }

    return this.utils.apiUrl(`/callCenter/${callCenterId}/announcement/${callCenterAnnouncement.id}`).pipe(
      mergeMap((url) => this.http.put<void>(url, formData)),
      wrapError('call-center-announcement-repository:update')
    );
  }

  updateSettings(callCenterId: number, settings: CallCenterAnnouncementSettings): Observable<void> {
    return this.utils.apiUrl(`/callCenter/${callCenterId}/announcements/settings`).pipe(
      mergeMap((url) => this.http.put<void>(url, settings)),
      wrapError('call-center-announcement-repository:update-settings')
    );
  }
}
